<template>
  <div class="page">
    <van-nav-bar title="实习总结" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <van-form @submit="onSubmit" style="height: calc(100vh - 130px)">
      <van-field style="margin-top: 10px" v-model="form.bt" name="标题" label="标题" input-align="right" error-message-align="right" placeholder="请输入" :rules="[{ required: true, message: '请填写标题' }]" />
      <van-field v-if="schoolCode != '14475'" style="margin-top: 10px" class="textarea" v-model="form.nr" rows="5" autosize label="内容" input-align="left" type="textarea" placeholder="请输入内容" :rules="[{ required: true, message: '请输入日志内容' }]" />
      
      <van-field v-if="schoolCode == '14475'" style="margin-top: 10px" class="textarea" v-model="form.sxzynrjc" rows="5" autosize label="实习主要内容及进程" label-width="200px"  input-align="left" type="textarea" placeholder="请输入实习主要内容及进程" :rules="[{ required: true, message: '请输入实习主要内容及进程' }]" />
      <van-field v-if="schoolCode == '14475'" style="margin-top: 10px" class="textarea" v-model="form.nr" rows="5" autosize label="主要收获和体会" label-width="200px"  input-align="left" type="textarea" placeholder="请输入主要收获和体会" :rules="[{ required: true, message: '请输入主要收获和体会' }]" />
      <van-field v-if="schoolCode == '14475'" style="margin-top: 10px" class="textarea" v-model="form.sxgzjy" rows="5" autosize label="实习单位对实习工作的建议" label-width="200px" input-align="left" type="textarea" placeholder="请输入实习单位对实习工作的建议" :rules="[{ required: true, message: '请输入实习单位对实习工作的建议' }]" />
      <van-field v-if="schoolCode == '14475'" style="margin-top: 10px" class="textarea" v-model="form.sxcg" rows="5" autosize label="实习成果" input-align="left" label-width="200px"  type="textarea" placeholder="请输入实习成果" :rules="[{ required: true, message: '请输入实习成果' }]" />
      <van-field name="uploader" label="">
        <template #input>
          <van-uploader accept="image/*" :max-size="5 * 1024 * 1024" @oversize="$toast('文件大小不能超过 5M ')" :max-count="1" :after-read="upload" v-model="fileList" />
        </template>
      </van-field>
      <div class="map">
        <el-amap ref="map" class="amap-box" :vid="'amap-vue'" :amap-manager="amapManager" :plugin="plugin"></el-amap>
      </div>
      <div class="position">
        <div class="title">
          <div>您当前所在位置</div>
          <div style="color: #0189F9;" @click="rePosition">重新定位</div>
        </div>
        <div class="content">
          <van-loading v-if="form.dz == ''" type="spinner" size="14" />
          {{ form.dz || '定位获取中…' }}
        </div>
      </div>
      <div class="button-box">
        <van-button round type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import  iApi  from '@/utils/internship'
import { AMapManager } from 'vue-amap'
import { mapGetters } from 'vuex'
let amapManager = new AMapManager()
export default {
  components: {},
  data() {
    let self = this
    return {
      schoolCode:sessionStorage.getItem("schoolCode"),
      isEdit: false,
      amapManager,
      plugin: [
        {
          pName: 'Geolocation',
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：5s
          buttonPosition: 'RB', //定位按钮的停靠位置
          zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                if (status == 'complete') {
                  self.complete(result)
                } else {
                  self.$toast.fail('定位失败！')
                }
              })
            },
          },
        },
      ],
      fileList: [],
      form: {
        sxjhid: '',
        dz: '',
        nr: '',
        bt: '',
        sxzjid: '', // 只在编辑的时候传
        sqzp: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      sxjhid: 'getSxjhid',
    }),
  },
  methods: {
    /**
     * @description: 地图定位完成
     * @param {Object} result 定位结果
     */
    complete(result) {
      this.form.dz = result.formattedAddress
    },
    /**
     * @description: 重新定位事件，获取地图插件通过重新调用方法，获取地址
     */
    rePosition() {
      this.form.dz = ''
      this.$refs.map.$plugins['AMap.Geolocation'].getCurrentPosition((status, result) => {
        if (status == 'complete') {
          this.complete(result)
        } else {
          this.$toast.fail('定位失败！')
        }
      })
    },
    /**
     * @description: 文件上传，通过上传组件，直接将file赋值
     * @param {*} e
     * @return {*}
     */
    upload(e) {
      this.form.sqzp = e.file
    },

    /**
     * @description: 表单提交
     * @param {*}
     * @return {*}
     */
    async onSubmit() {
      if(this.schoolCode == '14475'){
        if(this.form.sxzynrjc.indexOf("'") != -1){
          this.$toast('实习主要内容及进程输入内容存在非法字符，请检查后重新提交!')
          return false;
        }
        if(this.form.nr.indexOf("'") != -1){
          this.$toast('主要收获和体会输入内容存在非法字符，请检查后重新提交!')
          return false;
        }
        if(this.form.sxgzjy.indexOf("'") != -1){
          this.$toast('实习单位对实习工作的建议输入内容存在非法字符，请检查后重新提交!')
          return false;
        }
        if(this.form.sxcg.indexOf("'") != -1){
          this.$toast('实习成果输入内容存在非法字符，请检查后重新提交!')
          return false;
        }
      }else{
        if(this.form.nr.indexOf("'") != -1){
          this.$toast('输入内容存在非法字符，请检查后重新提交!')
          return false;
        }
      }
      
      this.form.sxjhid = this.sxjhid
      const res = await iApi.postSummaryData(this.form)
      if (res.code == '1') {
        this.$toast.success('提交实习总结成功')
        this.form = {
          sxjhid: '',
          dz: '',
          nr: '',
          bt: '',
          sxzjid: '', // 只在编辑的时候传
          sqzp: '',
        }
        setTimeout(() => {
          this.$router.go(-1)
        }, 800)
      }
    },
  },
  created() {
    console.log(this.$route.query)
    if (this.$route.query.edit) {
      this.isEdit = true
      let data = this.$route.query.data
      if(this.schoolCode == '14475'){
        this.form = {
          sxjhid: data.sxjhid,
          dz: '',
          sxzynrjc: data.sxzynrjc,
          nr: data.nr,
          sxgzjy: data.sxgzjy,
          sxcg: data.sxcg,
          bt: data.bt,
          sxzjid: data.sxzjid, // 只在编辑的时候传
          sqzp: '',
        }
      }else{
        this.form = {
          sxjhid: data.sxjhid,
          dz: '',
          nr: data.nr,
          bt: data.bt,
          sxzjid: data.sxzjid, // 只在编辑的时候传
          sqzp: '',
        }
      }
      
    }
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
}

.item-box {
  width: 315px;
  min-height: 50px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto 0;
  padding: 12px 15px;
  .title-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      // width: 280px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .status {
      margin-left: 10px;
      min-width: 46px;
      height: 20px;
      border: 1px solid #41b29c;
      border-radius: 10px;
      text-align: center;
      line-height: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #41b29c;
    }
  }
  .date {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin: 5px 0;
  }
  .tip-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    p {
      color: #0088f8;
    }
  }
}
.button-box {
  width: 375px;
  height: 70px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .van-button {
    width: 345px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px !important;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
  }
}
.map {
  overflow: hidden;
  width: 0px;
  height: 0px;
}
.position {
  margin-top: 10px;
  width: 345px;
  background: #ffffff;
  padding: 15px;
  .title {
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
  }
  .content {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #b2b2b2;
    margin-top: 5px;
    display: flex;
    align-items: center;
    .van-loading {
      position: relative;
      left: 0;
      margin-right: 10px;
    }
  }
}
.textarea {
  flex-direction: column;
  height: 200px;
  overflow-y:auto;
  .van-field__body {
    margin-top: 50px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/summary.vue